import { gql } from '@apollo/client';

export const UPSERT_PERIOD_GROUP = gql`
  mutation UpsertPeriodGroup($input: UpsertPeriodGroupInput!) {
    periodGroup: upsertPeriodGroup(input: $input) {
      id
    }
  }
`;
